import { useMemo } from "react";
import { useProductGroupOptions } from "../../shared/hook/useProductGroupOptions";

const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const PDF_MIME = "application/pdf";

const OPERATOR_ROLE_ID = 5;

export const canAccessLocalBilling = (userData: any) =>
  userData?.userPositionRu === "Администратор" ||
  (Array.isArray(userData?.selectRoleV2) &&
    userData.selectRoleV2.some(
      (role: { roleId: number }) => role.roleId === OPERATOR_ROLE_ID,
    ));

export const formatBillingAmount = (value?: number) => {
  if (value == null) return "-";
  return new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 8,
    maximumFractionDigits: 8,
  }).format(value);
};

export const formatBalanceReportAmount = (
  value?: number,
  options?: { signed?: "writeOff" | "receipt" },
) => {
  if (value == null) return "-";
  const abs = Math.abs(value);
  const formatted = new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs);

  if (options?.signed === "writeOff") {
    return value === 0 ? formatted : `−${formatted}`;
  }
  if (options?.signed === "receipt") {
    return value === 0 ? formatted : `+${formatted}`;
  }
  return formatted;
};

// Код ТГ → название на языке интерфейса
export const useProductGroupNames = () => {
  const { optionsByCode } = useProductGroupOptions();
  return useMemo(
    () => Object.fromEntries(optionsByCode.map((option) => [option.value, option.label])),
    [optionsByCode],
  );
};

export const formatProductGroups = (
  codes: string[] | undefined,
  names: Record<string, string>,
) => (codes ?? []).map((code) => names[code] ?? code).join(", ");

export const downloadXlsxBlob = (blob: Blob, fileName: string) => {
  const fileBlob =
    blob.type === XLSX_MIME ? blob : new Blob([blob], { type: XLSX_MIME });
  const url = window.URL.createObjectURL(fileBlob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const downloadPdfBlob = (blob: Blob, fileName: string) => {
  const fileBlob =
    blob.type === PDF_MIME ? blob : new Blob([blob], { type: PDF_MIME });
  const url = window.URL.createObjectURL(fileBlob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
};
